<app-preloader *ngIf="isLoading | async"></app-preloader>
<app-header></app-header>
<router-outlet (activate)="onActivate($event)"></router-outlet>
<app-footer></app-footer>
